import z from 'zod';
import { btnCellSchema } from './cell-types/btn.zod';
import { textCellSchema } from './cell-types/text.zod';
import { mediaCellSchema } from './cell-types/media.zod';
import { timerCellSchema } from './cell-types/timer.zod';
import { inputCellSchema } from './cell-types/input.zod';
import { dialogCellSchema } from './cell-types/dialog.zod';
import { markdownCellSchema } from './cell-types/markdown.zod';
import { dateTimeCellSchema } from './cell-types/datetime.zod';
import { workOrderModal } from './cell-types/work-order-modal.zod';
import { attrLookupCellSchema } from './cell-types/attr-lookup.zod';
import { processListCellSchema } from './cell-types/process-list.zod';
import { macroTargetCellSchema } from './cell-types/macro-target.zod';
import { materialLookupCellSchema } from './cell-types/material-lookup.zod';
import { circularProgressCellSchema } from './cell-types/circular-progress.zod';
import { workInstructionCellSchema } from './cell-types/work-instruction.zod';
import { workInstructionProcessListCellSchema } from './cell-types/work-instruction-process-list.zod';
import { displayProcessCellSchema } from './cell-types/display-process.zod';
import { selectCellSchema } from './cell-types/select.zod';
import { gaugeCellSchema } from './cell-types/gauge.zod';

// NOTE: a discriminated union requires all options to be of type ZodObject.
export const cellSchema = z.lazy(() => z.discriminatedUnion('type', [
    btnCellSchema,
    workOrderModal,
    textCellSchema,
    timerCellSchema,
    inputCellSchema,
    mediaCellSchema,
    dialogCellSchema,
    dateTimeCellSchema,
    markdownCellSchema,
    attrLookupCellSchema,
    processListCellSchema,
    macroTargetCellSchema,
    displayProcessCellSchema,
    materialLookupCellSchema,
    workInstructionCellSchema,
    circularProgressCellSchema,
    workInstructionProcessListCellSchema,
    selectCellSchema,
    gaugeCellSchema,
]));

